enum SignUpPassengerFormStep {
  accountData = "ACCOUNT_DATA",
  userData = "USER_DATA",
  summary = "SUMMARY",
}

export default SignUpPassengerFormStep;
